import React, { useEffect } from 'react';
import { makeStyles } from '@material-ui/core/styles';

// 고객 배송조회 전용 틀 — 사이트 헤더·푸터 없이 페이지가 머리까지 직접 그린다(components/track/TrackShell)
const useStyles = makeStyles(() => ({
  '@global': {
    'html, body, #root': { height: '100%', backgroundColor: '#fff' },
  },
}));

function TrackLayout({ children }) {
  useStyles();
  useEffect(() => { window.scrollTo(0, 0); }, []);
  return <React.Fragment>{children}</React.Fragment>;
}

export default TrackLayout;
